import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import { useIntegrationStore } from 'store/useIntegrationStore';
import http from 'utils/http';

const disconnectEveree = () => {
  const newEndpoints = endpoints.integrations.everee.disconnect;
  return http().delete(newEndpoints, {});
};

export function useDisconnectEveree() {
  const addIntegrationList = useIntegrationStore(state => state.addIntegrationList);

  return useMutation({
    mutationFn: disconnectEveree,
    onSuccess: ({ payload }) => {
      addIntegrationList(payload);
    },
  });
}
